/**
 * Created by rickborst on 25/04/2017.
 */

class Media {

    constructor (options = {}) { // eslint-disable-line no-unused-vars

        // TODO: Implement media data.

        return this;
    }
}

export default Media;


// WEBPACK FOOTER //
// ./src/js/models/asset/media.js